import React from 'react';
import { colors } from '../../../utils/theme';
import { View } from 'react-native';
import Text from '../Text';

export type NotificationCountIndicatorOwnProps = {
    count: number;
};

export type NotificationCountIndicatorProps = NotificationCountIndicatorOwnProps;

export const NOTIFICATION_COUNT_INDICATOR_SIZE = 18;

const NotificationCountIndicator: React.FC<NotificationCountIndicatorProps> = (props) => {
    if (!props.count) return null;

    return (
        <View
            style={{
                backgroundColor: colors.Success,
                borderRadius: NOTIFICATION_COUNT_INDICATOR_SIZE / 2,
                width: NOTIFICATION_COUNT_INDICATOR_SIZE,
                height: NOTIFICATION_COUNT_INDICATOR_SIZE,
                justifyContent: 'center',
                alignItems: 'center',
            }}
            testID="notification-count-indicator"
        >
            <Text color="White-Text" variant="body-2">
                {props.count > 9 ? '9+' : props.count}
            </Text>
        </View>
    );
};

export default React.memo(NotificationCountIndicator);
